import React from 'react';

const CommentEntry = ({ entry, data, readOnly, deleting, onDelete }) => {
  const t = data.t;
  const author = entry.author?.display_name || t.read('comment_ui.unknown_author');
  const initials = author.split(/\s+/).slice(0, 2).map((part) => part[0]).join('');
  const date = entry.created_at ? new Date(entry.created_at) : null;
  const timestamp = date && !Number.isNaN(date.getTime())
    ? new Intl.DateTimeFormat(t.lang === 'fr' ? 'fr-CA' : 'en-CA', { dateStyle: 'medium', timeStyle: 'short' }).format(date)
    : t.read('comment_ui.unknown_date');
  return (
    <article className="comment-entry">
      <span className="comment-avatar" aria-hidden="true">{initials}</span>
      <div className="comment-content">
        <div className="comment-meta"><strong>{author}</strong><time dateTime={entry.created_at || undefined}>{timestamp}</time>
          {entry.kind !== 'user_comment' && <span className="comment-kind">{t.read(`comment_ui.${entry.kind}`)}</span>}
        </div>
        <p className="comment-body">{entry.deleted ? t.read('comment_ui.deleted') : entry.body}</p>
        {entry.represented_user_id && <small>{t.read('comment_ui.on_behalf')}</small>}
        {!readOnly && !entry.deleted && entry.capabilities?.can_delete &&
          <button type="button" className="comment-action" disabled={deleting} onClick={() => onDelete(entry)}>{t.read('delete')}</button>}
      </div>
    </article>
  );
};
export default CommentEntry;
